<!-- 服务商管理 -->
<template>
  <v-container fluid>
    <!-- 查询条件：名称、状态 -->
    <v-row class="query-row">
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <v-text-field v-model="queryForm.name" label="名称" dense outlined clearable hide-details
          @keyup.enter="search()"></v-text-field>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <v-select v-model="queryForm.status" :items="statusOptions" item-text="label" item-value="value" label="状态"
          no-data-text="无" dense outlined clearable hide-details :menu-props="{ bottom: true, offsetY: true }">
        </v-select>
      </v-col>
      <v-col cols="12" xl="3" lg="3" md="6" sm="6">
        <a-space>
          <v-btn @click="getdata()" color="primary" dark tile>
            <v-icon small>mdi-magnify</v-icon>查询
          </v-btn>
          <v-btn @click="showadd" color="success" dark tile>
            <v-icon small>mdi-plus</v-icon>新增服务商
          </v-btn>
        </a-space>
      </v-col>
    </v-row>
    <v-card tile>
      <v-card-title class="d-flex align-center py-2 px-3" style="background-color: #fff;">
        <span class="text-subtitle-2">共 {{ list.length }} 条数据</span>
        <v-spacer></v-spacer>
      </v-card-title>
      <a-table size="small" :columns="headers" :data-source="list" row-key="_id" :pagination="false" bordered
        :locale="{ emptyText: '暂无数据' }" :scroll="{ x: width }">
        <!-- 地址、合同、备注超长省略，悬浮显示完整内容 -->
        <template slot="address" slot-scope="text">
          <a-tooltip v-if="text" :title="text" placement="topLeft">
            <span>{{ text }}</span>
          </a-tooltip>
        </template>
        <template slot="contract" slot-scope="text, record">
          <a-tooltip v-if="record.contract" :title="record.contract.originalname" placement="topLeft">
            <span>{{ record.contract.originalname }}</span>
          </a-tooltip>
          <a v-else href="javascript:;" @click="uploadcontract(record._id)">上传合同</a>
        </template>
        <template slot="remark" slot-scope="text">
          <a-tooltip v-if="text" :title="text" placement="topLeft">
            <span>{{ text }}</span>
          </a-tooltip>
        </template>
        <template slot="status" slot-scope="text, record">
          <a-tag :color="record.status === 1 ? 'green' : 'red'">{{ record.status === 1 ? "启用" : "禁用" }}</a-tag>
        </template>
        <template slot="action" slot-scope="text, record">
          <a-space>
            <a @click="showedit(record._id)">编辑</a>
            <a-divider type="vertical" />
            <a-popconfirm :title="`确认删除服务商「${record.name}」?`" ok-text="确定" cancel-text="取消" placement="left"
              @confirm="remove(record._id)">
              <a class="error--text">删除</a>
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
    </v-card>
    <!-- 新增 / 编辑服务商弹窗 -->
    <v-dialog v-model="formmodel" max-width="580px" persistent scrollable>
      <v-form ref="form" v-model="formvalid" :lazy-validation="true">
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            {{ formtitle }}
            <v-icon @click="cancelsave">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container style="max-height:600px;overflow-y: auto;">
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="form.name" :rules="[vrules.required]" dense outlined>
                    <template v-slot:label>
                      名称 <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="form.linkman" label="联系人" dense outlined>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="form.linkphone" label="联系电话" dense outlined>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="form.address" label="地址" dense outlined></v-text-field>
                </v-col>
                <v-col sm="6">
                  <v-text-field v-model="form.payee" label="收款人" dense outlined></v-text-field>
                </v-col>
                <v-col sm="6">
                  <v-text-field v-model="form.bankaccount" label="账号" dense outlined></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="form.bankname" label="开户行" dense outlined></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-radio-group v-model="form.status" row class="mt-0 pt-2">
                    <v-radio color="success" label="启用" :value="1"></v-radio>
                    <v-radio color="error" label="禁用" :value="0"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12">
                  <v-textarea v-model="form.remark" label="备注" dense outlined rows="2"></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text tile @click="cancelsave">取消</v-btn>
            <v-btn color="primary" dark tile :disabled="!formvalid" @click="save">保存</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <input type="file" accept=".doc,.pdf" ref="fileref" @change="change" style="display: none;" />
  </v-container>
</template>

<script>
import _ from "underscore";

export default {
  name: "Servicer",
  data() {
    return {
      queryForm: {
        name: "",
        status: null,
      },
      statusOptions: [
        { label: "启用", value: 1 },
        { label: "禁用", value: 0 },
      ],
      headers: [
        { title: "名称", dataIndex: "name", width: 200, align: "left" },
        { title: "联系人", dataIndex: "linkman", width: 100, align: "center" },
        { title: "联系电话", dataIndex: "linkphone", width: 140, align: "center" },
        { title: "地址", dataIndex: "address", scopedSlots: { customRender: "address" }, width: 240, align: "left", ellipsis: true },
        { title: "收款人", dataIndex: "payee", width: 100, align: "center" },
        { title: "开户行", dataIndex: "bankname", width: 180, align: "left", ellipsis: true },
        { title: "账号", dataIndex: "bankaccount", width: 180, align: "center" },
        { title: "合同", dataIndex: "contract", scopedSlots: { customRender: "contract" }, width: 180, align: "left", ellipsis: true },
        { title: "状态", dataIndex: "status", scopedSlots: { customRender: "status" }, width: 90, align: "center" },
        { title: "备注", dataIndex: "remark", scopedSlots: { customRender: "remark" }, width: 180, align: "left", ellipsis: true },
        { title: "操作", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 120, align: "center", fixed: "right" },
      ],
      list: [],
      vrules: {
        required: (value) => !!value || "不能为空",
      },
      formtitle: "",
      formmodel: false,
      formvalid: true,
      form: {},
      uploadid: null,
    };
  },
  computed: {
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 120), 0);
    },
  },
  mounted() {
    this.getdata();
  },
  methods: {
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehicleserviceprovider/list", { ...this.queryForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    info(_id) {
      this.$toast.loading({ message: "" });
      return this.$api.doAPI("/vehicleserviceprovider/info", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.form = res.data.dataForm;
          this.formmodel = true;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showadd() {
      this.info().then(() => {
        this.formtitle = "添加服务商";
      });
    },
    showedit(_id) {
      this.info(_id).then(() => {
        this.formtitle = "编辑服务商";
      });
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehicleserviceprovider/save", { dataForm: this.form }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.$message.success("已保存");
          this.formmodel = false;
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    cancelsave() {
      this.$refs.form.resetValidation();
      this.formmodel = false;
    },
    remove(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehicleserviceprovider/remove", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.$message.success("已删除");
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    uploadcontract(_id) {
      this.uploadid = _id;
      this.$refs.fileref.click()
    },
    change(e) {
      let file = e.target.files[0];
      if (!file) return;
      this.upload(file);
    },
    async upload(file) {
      this.$toast.loading({ message: "" });
      const slicefiles = this.$utils.sliceFile(file.size);
      const faid = this.$utils.uuid();
      for (let j = 0; j < slicefiles.length; j++) {
        let slicefile = slicefiles[j];
        const formData = new FormData();
        if (slicefile.chunks > 1) {
          let _file = file.slice(slicefile.from, slicefile.to);
          formData.set("file", _file);
        }
        else {
          formData.set("file", file);
        }
        formData.set("faid", faid);
        formData.set("chunk", slicefile.chunk);
        formData.set("chunks", slicefile.chunks);
        formData.set("originalname", file.name);
        formData.set("id", this.uploadid);
        try {
          let res = await this.$api.doUpload("/vehicleserviceprovider/plupload", formData);
          if (res.code === 0) {
            if (slicefile.chunk + 1 === slicefile.chunks) {
              this.$toast.clear();
            }
          }
          else {
            this.$toast.clear();
            this.$alert(res.msg);
            break;
          }
        } catch (e) {
          console.error(e);
          this.$toast.clear();
          this.$alert(e.message);
          break;
        }
      }
      this.getdata();
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/* 查询条件行与下方表格保持间距 */
/deep/ .row.query-row {
  margin-bottom: 16px !important;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

p {
  margin: 0;
}
</style>
